import {getModule} from 'vuex-module-decorators';
import {ApplicationBarStandaloneRequest, RequestCookies} from '../../build/swagger-code-extranet-api-definition/models';
import ApplicationBarStoreModule from '../store/modules/applicationBar.module';
import {Vue} from 'vue-property-decorator';
import {Store} from 'vuex';
import Cookies from 'js-cookie';

class AppSetupService extends Vue {

    public async loadApplicationBar(store: Store<any>) {
        const applicationBarStore: ApplicationBarStoreModule = getModule(ApplicationBarStoreModule, store);
        const requestCookies: RequestCookies[] = Object.entries(Cookies.get()).map((entry) => {
            return {
                key: entry[0],
                value: entry[1],
            };
        });
        const urlLocale = new URL(window.location.toString()).searchParams.get('locale');
        const applicationBarStandaloneRequest: ApplicationBarStandaloneRequest = {
            currentBaseUrl: window.location.href,
            urlLocale,
            requestCookies,
        };
        await applicationBarStore.loadApplicationBarStandalone(applicationBarStandaloneRequest);
    }
}

const appSetupService = new AppSetupService();

export default appSetupService;

